// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__6qaX8","brand":"styles_brand__76FHp","title":"styles_title__UFq8r","description":"styles_description__6shdx","row":"styles_row__64cYm"};